module.exports = __webpack_public_path__ + "img/logo_e-egyetem_classroom_logo.ae58626a.png";